// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 792) return "bundle.e37fc1b05bd2dfe9e633e47babc5f510.css";
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "c4d0e9e8432ffa268531f4acadbd8d88" + ".css";
};